import { getFormatedTimeString } from "../Helper/utils";
import { Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";

export const SlotsSplitView = ({ slots }) => {
  const customerSlots = [];
  slots.map((item, index) => {
 
   let startTime = item.startTime;
   while (startTime + item.split <= item.endTime) {
     let endTime = startTime + item.split;
     customerSlots.push(
       <TableCell
         key={`${startTime}-${endTime}`}
         className="border border-top-gray-400 p-2 text-mb-gray-900 text-sm flex justify-center"
       >
        <div className="flex justify-center ">  {`${getFormatedTimeString(startTime)} - ${getFormatedTimeString(endTime)}`} </div> 
       </TableCell>
     );
     startTime = endTime;

    }});

    if(customerSlots.length % 3 != 0){
      customerSlots.push(<TableCell
        className="border border-top-gray-400 p-2 flex justify-center"
      >
      </TableCell>)
    }
  
  return (
    <div>
          <TableContainer>
            <Table>
              <TableBody  className="grid grid-cols-3 gap-4" >
                {customerSlots.reduce((rows, cell, i) => {
                  if (i % 3 === 0) rows.push([]);
                  rows[rows.length - 1].push(cell);
                  return rows;
                }, []).map((row, i) => (
                  <TableRow key={i}>{row}</TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
    </div>
  );
};

